/* eslint-disable import/no-webpack-loader-syntax */ import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import halfRoseUrl from '../../../assets/gems/half_rose.svg?inline';
export function HalfRose({ ...props }) {
    return /*#__PURE__*/ _jsx("img", {
        ...props,
        src: halfRoseUrl,
        alt: "HalfRoseImage"
    });
}
